import { delay as Et } from "../../common-lib/utils/delay.js";
import { maskString as Rt } from "../../common-lib/utils/string.js";
import { ContractEventType as mt, DELAY_REFETCH_AFTER_CONTRACT_SUCCESS as yt, GAS_FEE_PRIORITY as It } from "../constants/contract.js";
import Ot from "./graphql/useConfirmTransaction.js";
import St from "./useVerifyContractTransaction.js";
import { waitForTransactionReceiptWithReason as _t } from "../utils/waitForTransactionReceiptWithReason.js";
import { CurrencyTokenType as Pt } from "../../currency-lib/constants/currency.js";
import { ChainType as dt } from "../../temp-lib/constants/chain.js";
import { ContractOperation as O } from "../../temp-lib/constants/contract.js";
import { ERROR_CODE as g } from "../../temp-lib/constants/error.js";
import { RETRY as vt } from "../../temp-lib/constants/retry.js";
import { ScreenLogType as ft } from "../../temp-lib/constants/screenLog.js";
import { WalletExtensionRdns as k } from "../../temp-lib/constants/web3.js";
import { useAccountContext as Gt } from "../../temp-lib/contexts/account/AccountContext.js";
import { useMessageContext as Wt } from "../../temp-lib/contexts/share/MessageContext.js";
import { CustomError as h } from "../../temp-lib/errors/customError.js";
import Dt from "../../temp-lib/hooks/generic/useChainSwitcher.js";
import Lt from "../../temp-lib/hooks/generic/useScreenLog.js";
import kt from "../../temp-lib/hooks/web3/useWeb3.js";
import { isIosOrAndroid as Bt } from "../../temp-lib/util/browser/index.js";
import { isProduction as Ft } from "../../temp-lib/util/environment/index.js";
import { walletRdnsToType as Mt } from "../../temp-lib/util/wallet/walletRdnsToType.js";
import { RoninVRFDescription as xt, RoninVRFTitle as $t } from "../../wallet-lib/components/RoninVRFMessage.js";
import { MobileWalletSnackBarMode as Ht } from "../../wallet-lib/constants/index.js";
import { useRoninWalletSnackBarContext as Ut } from "../../wallet-lib/contexts/RoninWalletSnackbarContext.js";
import bt from "../../wallet-lib/hooks/useMktErrorHandling.js";
import qt from "../../wallet-lib/hooks/useWalletAddress.js";
import { getConnectors as Jt, getAccount as B, connect as Vt, readContract as Kt, writeContract as Yt, getGasPrice as jt, estimateGas as Qt } from "@wagmi/core";
import zt from "p-retry";
import * as i from "ramda";
import { useState as wt, useCallback as m } from "react";
import { useTranslation as Xt } from "react-i18next";
import { getAbiItem as Zt, decodeEventLog as pt, encodeFunctionData as te } from "viem";
import { jsx as gt } from "react/jsx-runtime";
const ke = (r) => {
  const {
    t: y
  } = Xt(), {
    intercept: v
  } = Lt(), {
    correctNetwork: F,
    switchToRequriedNetwork: U,
    walletInstalled: b,
    getWalletRdnsFromWalletType: q,
    wagmiConfig: M
  } = kt(), {
    openSnackBar: J
  } = Ut(), {
    verify: V
  } = St(), {
    account: E,
    isLoggedIn: K,
    setWrongNetwork: Y
  } = Gt(), {
    showErrorPopup: x
  } = bt(), {
    compareAddress: j
  } = qt(), {
    mutate: Q
  } = Ot(), {
    detectWalletType: G,
    getContractAbi: z,
    getContractAddress: X,
    getChainImage: Z,
    getChainIdByWalletType: W
  } = Dt(), [Ct, p] = wt(!1), [Nt, ht] = wt(null), {
    showGeneralError: tt,
    setInfo: D,
    cleanInfo: et
  } = Wt(), R = m(() => {
    if (i.isNil(M))
      throw new h("wagmi config is null", g.CONTRACT.WAGMI_CONFIG_IS_NULL);
    return M;
  }, [M]), nt = m((t, e) => {
    switch (t.type) {
      case mt.REQUEST_ID:
        return i.pathOr("", [t.eventName, "returnValues", "_requestHash"], e);
      case mt.TRANSACTION_HASH:
        return i.pathOr("", [t.eventName, "transactionHash"], e);
      default:
        return "";
    }
  }, []), ot = m(async (t, e, o, c, s) => {
    var a;
    const n = R(), l = Jt(n);
    if (i.isNil(o) || i.isEmpty(o))
      throw new h("no method found", g.CONTRACT.SKIP_OPERATION);
    if (c === O.SEND) {
      if (!B(n).isConnected) {
        const _ = await ((a = n.storage) == null ? void 0 : a.getItem("recentConnectorId")), N = [q(s), _, k.Ronin, k.Okx, k.WalletConnect].filter((f) => f && Object.values(k).includes(f) && b(Mt(f))).map((f) => l.find((I) => I.id === f)).find(Boolean);
        N && await Vt(n, {
          connector: N,
          chainId: W(s)
        });
      }
      let T = B(n);
      if (!T.isConnected)
        throw new h("no connected account", g.LOGIN.CANNOT_GET_ACCOUNT_RESPONSE);
      if (!await F()) {
        if (await U(), !await F())
          throw new h("Wrong network", g.LOGIN.WRONG_NETWORK);
        T = B(n);
      }
      if (!j(E.walletAddress, T.address))
        throw D({
          blocking: !0,
          confirm: y("common.popup.got_it"),
          icon: Z(s),
          message: y("wallet.switch_address"),
          tag: Rt(E.walletAddress || ""),
          title: y("wallet.wrong_address")
        }), new h("stored wallet address not match with current wallet address", g.CONTRACT.WALLET_ADDRESS_MISMATCH);
    }
    if (!Zt({
      abi: t,
      name: o
    }))
      throw new h(`Method "${o}" not found on ${e}`, g.CONTRACT.METHOD_NOT_FOUND);
  }, [E.walletAddress, y, j, F, W, q, Z, R, D, U, b]), rt = m(async (t) => {
    const {
      contract: e
    } = t || {}, o = G(), c = z((e == null ? void 0 : e.abi) || (r == null ? void 0 : r.abi), {
      walletType: o
    }), s = X((e == null ? void 0 : e.address) || (r == null ? void 0 : r.address), {
      walletType: o
    }), n = (e == null ? void 0 : e.method) || (r == null ? void 0 : r.method) || "";
    return {
      abi: c,
      address: s,
      method: n,
      walletType: o
    };
  }, [G, z, X, r == null ? void 0 : r.abi, r == null ? void 0 : r.address, r == null ? void 0 : r.method]), at = m(async (t, e, o, c, s) => {
    const n = R(), l = B(n), a = () => {
      var u;
      const d = i.pathOr(void 0, ["ronin", "value"], t);
      if (i.isNotNil((u = t.ronin) == null ? void 0 : u.gasLimit) && i.isNotNil(d)) {
        const A = BigInt(i.pathOr("0", ["balances", Pt.Ron, "amount"], E)), w = BigInt(d);
        if (A < w && t.isVrf)
          throw D({
            blocking: !0,
            confirm: y("common.popup.ok"),
            message: /* @__PURE__ */ gt(xt, {
              skipDescription: !0
            }),
            title: /* @__PURE__ */ gt($t, {
              title: y("wallet.ronin.vrf.not_enough_balance")
            }),
            onConfirm: et
          }), new h("not enough balance", g.CONTRACT.NOT_ENOUGH_BALANCE_FOR_GAS_FEE);
      }
    }, C = async () => await jt(n, {
      chainId: l.chainId
    }), T = async () => {
      var A, w;
      const d = i.pathOr(void 0, ["ronin", "gasLimit"], t);
      return i.isNotNil(d) ? d : await Qt(n, {
        type: "legacy",
        account: l.address,
        to: o,
        value: (A = t == null ? void 0 : t.ronin) != null && A.value ? BigInt((w = t == null ? void 0 : t.ronin) == null ? void 0 : w.value) : void 0,
        data: te({
          abi: e,
          functionName: c,
          args: s
        })
      });
    }, S = async () => !i.includes(E.chainType, [dt.Polygon, dt.PolygonTestnet]) ? null : It, _ = () => {
      var d;
      return (d = t == null ? void 0 : t.ronin) == null ? void 0 : d.value;
    };
    a();
    const N = await C(), f = await T(), I = await S(), P = _();
    return {
      from: l.address,
      gasPrice: N,
      gas: BigInt(f),
      maxPriorityFeePerGas: I ? BigInt(I) : null,
      value: BigInt(P || "0")
    };
  }, [R, E, D, y, et]), ct = m((t) => {
    var c;
    const e = t.shortMessage || i.propOr("unknown error", "message", t), o = "Internal JSON-RPC error.";
    if (t.cause)
      return {
        code: (c = t.cause) == null ? void 0 : c.code,
        message: t.shortMessage
      };
    if (i.startsWith(o, e)) {
      const s = i.pipe(i.replace(o, ""), i.replace(`/
/g`, ""), JSON.parse), {
        code: n,
        message: l
      } = s(e);
      return {
        code: n,
        message: l
      };
    } else
      return {
        code: g.CONTRACT.UNSPECIFIED,
        message: e
      };
  }, []), st = m(async (t, e, o, ...c) => {
    const s = R();
    return await Kt(s, {
      address: t,
      abi: e,
      functionName: o,
      args: c,
      chainId: W(G())
    });
  }, [G, W, R]), it = m(async (t, e, o, c, ...s) => {
    var I, P, d;
    const n = R();
    console.group("contract"), console.info(`address: ${t}`), console.info(`method: ${o}
args:
 ${JSON.stringify(s, null, 2)}`), console.groupEnd();
    const l = c || {}, {
      callbacks: a,
      verifyEvent: C
    } = l, T = await at(l, e, t, o, s), S = {
      abi: e,
      address: t,
      functionName: o,
      args: s,
      gasPrice: T.gasPrice || void 0,
      gas: T.gas || void 0,
      value: T.value || void 0,
      type: "legacy",
      __mode: "prepared"
    }, _ = Yt(n, S);
    Bt() && !window.ronin && !window.okxwallet && J(Ht.SignTransaction), (I = a == null ? void 0 : a.onSent) == null || I.call(a, S);
    let N;
    try {
      const u = await _;
      if ((P = a == null ? void 0 : a.onTransactionHash) == null || P.call(a, u), N = await _t(n, {
        hash: u
      }), console.group("contract"), console.info(`receipt:
 ${JSON.stringify(N, null, 2)}`), console.groupEnd(), (d = a == null ? void 0 : a.onReceipt) == null || d.call(a, N), u)
        try {
          await Q(u);
        } catch (A) {
          console.error(A);
        }
    } catch (u) {
      throw console.group("contract"), console.info(`error:
${JSON.stringify(u, null, 2)}`), console.groupEnd(), u;
    }
    const f = N.logs.reduce((u, A) => {
      try {
        const w = pt({
          abi: e,
          eventName: C == null ? void 0 : C.eventName,
          data: A.data,
          topics: A.topics
        });
        return w != null && w.eventName && (u[w.eventName] = {
          eventName: w.eventName,
          transactionHash: N.transactionHash,
          returnValues: w.args
        }), u;
      } catch {
        return u;
      }
    }, {});
    return i.isNotNil(f) && !i.isEmpty(f) && !i.isNil(C) && !await V({
      uniqueID: nt(C, f),
      uniqueIDType: C.type,
      eventName: C.eventName
    }) ? (tt("Unknown error(s) occured"), null) : (await Et(yt), f);
  }, [R, at, J, Q, V, nt, tt]), lt = m((t) => {
    if (i.is(h, t))
      return t;
    const {
      code: e,
      message: o
    } = ct(t);
    return new h(o, e);
  }, [ct]), ut = m((t, e, o, c, ...s) => {
    console.error(t.stack);
    const n = lt(t), l = Ft() ? "hidden on production" : s;
    switch (n.code) {
      case g.LOGIN.WRONG_NETWORK:
        throw K && Y(c), n;
      case g.CONTRACT.SKIP_OPERATION:
        throw console.warn(`
Contract skipped:

Address: [${e}]

Method: [${o}]

Args: [${l}]
 
${n}`), n;
      case g.CONTRACT.USER_DENIED_TRANSACTION:
        throw x(n), n;
      default:
        throw x(n), console.error(`
Contract error:

Address: [${e}]

Method: [${o}]

Args: [${l}]
 
${n}`), n;
    }
  }, [K, lt, Y, x]), L = m(async (t, e, ...o) => {
    const {
      abi: c,
      address: s,
      method: n,
      walletType: l
    } = await rt(e);
    if (!E.walletAddress && t === O.SEND)
      throw new h("no wallet address found", g.CONTRACT.WALLET_ADDRESS_MISMATCH);
    try {
      p(!0), await ot(c, s, n, t, l);
      let a = null;
      switch (t) {
        case O.CALL: {
          a = await zt(() => st(s, c, n, ...o), vt.CONTRACT.DEFAULT);
          break;
        }
        case O.SEND: {
          a = await it(s, c, n, e, ...o);
          break;
        }
      }
      return ht(a), a;
    } catch (a) {
      ut(a, s, n, l, ...o);
    } finally {
      p(!1);
    }
  }, [rt, E.walletAddress, ot, st, it, ut]), $ = m(async (t, ...e) => {
    var c;
    return v({
      input: e,
      operation: ((c = t == null ? void 0 : t.contract) == null ? void 0 : c.method) || (r == null ? void 0 : r.method),
      type: ft.Contract,
      runJob: L
    })(O.CALL, t, ...e);
  }, [v, L, r == null ? void 0 : r.method]), H = m(async (t, ...e) => {
    var c;
    return v({
      input: e,
      operation: ((c = t == null ? void 0 : t.contract) == null ? void 0 : c.method) || (r == null ? void 0 : r.method),
      type: ft.Contract,
      runJob: L
    })(O.SEND, t, ...e);
  }, [v, L, r == null ? void 0 : r.method]), Tt = m(async (...t) => $(null, ...t), [$]), At = m(async (...t) => H(null, ...t), [H]);
  return {
    loading: Ct,
    call: Tt,
    callWithOption: $,
    send: At,
    sendWithOption: H,
    data: Nt
  };
};
export {
  ke as default
};
//# sourceMappingURL=useContract.js.map
